import clsx from 'clsx';
export const getFreezeProps = (columns, index, freezeMinWidth = 150) => {
  const previous = index > 0;
  const next = index < columns.length - 1;
  const prevColumn = previous ? columns[index - 1] : null;
  const nextColumn = next ? columns[index + 1] : null;
  const className = clsx({
    'column-freeze-start-border': nextColumn && !nextColumn.freeze,
    'column-freeze-end-border': prevColumn && !prevColumn.freeze
  });
  const left = index < columns.length - index;
  let sideOffset = 0;
  if (left) {
    for (let i = 0; i < index; i++) {
      const iColumn = columns[i];
      sideOffset += iColumn.minWidth ? iColumn.minWidth : freezeMinWidth;
    }
  } else {
    for (let i = columns.length - 1; i > index; i--) {
      const iColumn = columns[i];
      sideOffset += iColumn.minWidth ? iColumn.minWidth : freezeMinWidth;
    }
  }
  const column = columns[index];
  const style = {
    minWidth: column.minWidth ? column.minWidth : freezeMinWidth,
    left: left ? sideOffset : undefined,
    right: left ? undefined : sideOffset
  };
  return {
    className,
    style
  };
};